import { Outlet } from 'react-router-dom';
import { LayoutDefault } from '../components/layout/default/layoutDefault';

export default function PublicRoute() {
    return (
        <LayoutDefault>
            <Outlet />
        </LayoutDefault>
    );
}
